<template>
	<!-- Balance and main content -->
	<div class="w-full md:w-3/4 lg:w-4/5 h-full flex flex-col items-start pair-bg overflow-y-auto custom-scrollbar md:rounded-tr-2xl md:rounded-bl-none md:rounded-tl-none rounded-b-2xl z-10">
		<div class="flex items-center justify-between w-full px-4 md:pt-12 md:px-8">
			<div class="flex items-center justify-center ml-4 md:ml-0">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkMainSend : lightMainSend" alt="Wallet Icon" class="w-6 h-6 md:w-8 md:h-8 mr-3"/>
				<h1 class="text-2xl md:text-4xl font-archivomedium text-[var(--text-color)]">
					{{ isApprove ? 'Approve' : isSign ? 'Sign' : isSwap ? 'Swap' : 'Send' }}
				</h1>
				<img :src="selectedChain.icon" alt="Chain Icon" class="w-8 h-8 md:w-10 md:h-10 mb-4 ml-2 mt-4 cursor-pointer md:top-16 md:right-16"/>
				<button @click="$emit('backToOverview')" class="hidden md:block absolute top-8 right-8">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
				</button>
			</div>
			<!-- back button -->
			<button @click="$emit('back-to-psbt')" class="block md:hidden ml-auto md:mt-2 mr-4 flex items-center space-x-1 px-3 py-2 text-sm font-archivoregular text-[var(--secondary-text-color)] bg-[var(--accent-color-50)] hover:bg-[var(--accent-color-30)] rounded-full transition-colors">
				<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
				</svg>
				<span class="hover:text-[var(--secondary-text-color)] text-xs">Back</span>
			</button>
		</div>

		<!-- Body -->
		<div class="my-2 mx-auto w-full md:w-[80%] lg:w-[65%] xl:w-[50%] p-4">
			<h2 class="text-2xl font-archivomedium my-4 text-center text-[var(--text-color)]">
				Broadcasting...
			</h2>
			<div class="flex flex-col items-center h-72 md:h-80">
				<qrcode-stream @decode="$emit('decode', $event)" @init="$emit('init', $event)" class="w-full h-60 md:h-80 rounded-lg"/>
			</div>
			<p class="mb-4 mt-4 text-center font-archivolight text-[var(--secondary-text-color)]">
				Scan codes to broadcast transaction
			</p>
			<div class="flex justify-center mb-4">
				<div class="loader"></div>
			</div>
			<p class="mb-4 text-center text-[var(--accent-color)]">
				{{ percentSynced }}
			</p>
			<div class="p-4">
				<button @click="$emit('back-to-psbt')" class="mt-4 w-full font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
					Back
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { QrcodeStream } from 'vue3-qrcode-reader';
	import lightMainSend from '../assets/SendIconLightTheme.png';
	import darkMainSend from '../assets/SendIconDarkTheme.png';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		selectedChain: { type: Object, required: true },
		percentSynced: { type: String, required: true },
		isApprove: { type: Boolean, default: false },
		isSign: { type: Boolean, default: false },
		isSwap: { type: Boolean, default: false }
	});

	const emit = defineEmits([
		'decode',
		'init',
		'back-to-overview',
		'back-to-psbt'
	]);
</script>

<style scoped>
/* Loader styling is shared with App.vue’s <style> so no extra CSS needed here. */
</style>
